import branch from 'recompose/branch';
import renderComponent from 'recompose/renderComponent';
import Indicator from './indicator';

function isLoading({status}) {
	return status && !status.isLoaded && !(status.succeeded && !status.pending);
}

export default branch(
	isLoading,
	renderComponent(Indicator)
);



// WEBPACK FOOTER //
// ./src/client/components/common/with-loading-indicator/index.js